import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@material-ui/core";

import { IconButtonDatatable, Modal } from "App/Component/ui";
import { SelectIcon } from "App/Assets";
import { STYLE_DEFAULT_MASTER } from "App/constants";

const useStyles = STYLE_DEFAULT_MASTER;

export default function ModalKualifikasiPendidikan({
  setShowModal,
  rows,
  formData,
  setFormData,
  setLabelQualification,
  item,
}) {
  const classes = useStyles();
  return (
    <Modal title={"KUALIFIKASI PENDIDIKAN"} width={"40%"} show={setShowModal}>
      <Paper
        style={{
          boxShadow: "none",
          marginLeft: "-12px",
        }}>
        <TableContainer
          className='custom-scrollbar'
          style={{ minHeight: "500px" }}>
          <Table
            className={classes.table}
            aria-labelledby='tableTitle'
            size={"medium"}
            aria-label='enhanced table'>
            <TableHead
              style={{
                border: "1px solid #fafafa",
              }}>
              <TableRow
                style={{
                  backgroundColor: "#fff",
                }}>
                <TableCell align='left'>ACT</TableCell>
                <TableCell align='left'>KUALIFIKASI PENDIDIKAN</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? "#F5F5F5" : "transparent",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      width='5%'
                      padding='none'
                      align='center'>
                      <IconButtonDatatable
                        color='secondary'
                        aria-label='delete'
                        onClick={() => {
                          setFormData({
                            ...formData,
                            edu_qualified: row.id,
                            qualification_name: row.name,
                          });

                          localStorage.setItem(
                            item,
                            JSON.stringify({
                              ...formData,
                              qualification_name: row.name,
                              edu_qualified: row.id,
                            })
                          );

                          setLabelQualification(row.name);
                          setShowModal(false);
                        }}
                        style={{
                          background: "#D8D8D8",
                          borderRadius: "8px",
                          padding: "6px",
                        }}>
                        <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                      </IconButtonDatatable>
                    </TableCell>

                    <TableCell align='left'>{row.name}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Modal>
  );
}
